'use es6';

import get from 'transmute/get';
import { createSelector } from 'reselect';
import { getLegalConsentEnabled, getIsLegitimateInterest } from './BookInfoSelectors';
export var getStagedLegalConsentResponses = get('stagedLegalConsentResponses');
export var getLegalConsentResponses = get('legalConsentResponses');
export var getLegitimateInterestConfirmed = get('legitimateInterestConfirmed');

var allRequiredResponsesCollected = function allRequiredResponsesCollected(consentResponses) {
  if (!consentResponses) {
    return false;
  }

  return consentResponses.filter(function (response) {
    return response.required;
  }).every(function (requiredResponse) {
    return requiredResponse.consented;
  });
};

export var getAllStagedRequiredConsentCollected = createSelector([getStagedLegalConsentResponses], allRequiredResponsesCollected);
export var getAllRequiredConsentCollected = createSelector([getLegalConsentEnabled, getIsLegitimateInterest, getLegitimateInterestConfirmed, getLegalConsentResponses], function (legalConsentEnabled, isLegitimateInterest, legitimateInterestConfirmed, consentResponses) {
  return !legalConsentEnabled || (isLegitimateInterest ? legitimateInterestConfirmed : allRequiredResponsesCollected(consentResponses));
});